import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Solutions() {
  return (
    <div className="the_solution  case_soundly">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={12} lg={4} xl={4} xxl={4} className="my-auto">
            <h2>
              <span>The</span> Solution
            </h2>
            <p>
              Engaging in the development and designing of the product,
              Tekrevol's dedicated team leveraged the streamlined technologies
              to support the primary features of the Soundly application. While
              the technologies were being reiterated and integrated, the design
              team created a unique and highly engaging UI/UX of the
              application.
            </p>
            <p>
              During the development phase, the imperative features, i.e.,
              profile creation, playlist option, offline music listening,
              donating option, and other critical features, were integrated and
              tested by the quality assurance team to ensure that the app
              functioned marvelously.
            </p>
            <p>
              The three phases – development, designing, and quality assurance
              were efficiently implemented. By the end of the process, a fully
              functional mobile application was represented to the client.
            </p>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={4}
            xl={4}
            xxl={4}
            className="mt-auto text-center resp_order"
          >
            <StaticImage
              src="../../../images/case-studies/soundly/solutions_img.webp"
              alt="Soundly_TekRevol"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={323}
              height={832}
            />
          </Col>
          <Col xs={12} md={6} lg={4} xl={4} xxl={4} className="my-auto">
            <ul>
              <li>
                Understanding the client's vision behind the Soundly app and
                transforming that vision into a disruptive reality.
              </li>
              <li>
                Discovering the features, functionalities, UI/UX, and other
                factors that would position the Soundly app as a more modernized
                platform than others.
              </li>
              <li>
                Streamlining the technologies to be integrated into the Soundly
                app to ensure high performance and efficiency.
              </li>
              <li>
                Developing efficient sprint sessions based on different phases
                to get the app developed, designed, and published on time.
              </li>
            </ul>
            <p>
              The following teams collectively worked to build the platform
              exclusively for entertainment lovers:
            </p>
            <ul>
              <li>Project manager</li>
              <li>Backend developers</li>
              <li>Frontend developer</li>
              <li>QA engineer</li>
            </ul>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Solutions;
